/*  eslint-disable @typescript-eslint/naming-convention */
import { Brandfolder as BF, Organization as Org } from '@brandfolder/types';

export interface Brandfolder extends BF {
  key: string;
}

export interface Organization extends Org {
  key: string;
}

export enum PeoplePageParamKeys {
  AssetIds = 'ids',
  Filter = 'filter',
  Search = 'search',
  Sort = 'sort',
  Page = 'page',
}

export enum FilterValues {
  All = 'all',
  Tagged = 'tagged',
  Untagged = 'untagged',
}

export enum SortValues {
  Newest = 'upload-date-descending',
  Oldest = 'upload-date-ascending',
  Least = 'frequency-least',
  Most = 'frequency-most',
  Ascending = 'name-ascending',
  Descending = 'name-descending',
}

export interface EmptyStateContent {
  [key: string]: {
    heading: string;
    imgSrc: string;
    subheading: string;
  };
}

export type FaceFetchType =
  | 'add-people-tag'
  | 'autocomplete'
  | 'get-hero-image'
  | 'merge'
  | 'people-page-faces'
  | 'person-details'
  | 'remove-face';

export interface PeoplePageRequestParams {
  asset_id?: string[];
  page_num?: number;
  per_page_count?: number;
  sort_by?: SortValues;
  status?: FilterValues;
}

export interface PeoplePage {
  thumbnail_url: string;
  person_id: string;
  bounding_box?: {
    left: number;
    top: number;
    width: number;
    height: number;
  };
  name: string;
}

export interface PersonDetailsRequestParams {
  page_num?: number;
  person_id: string;
  per_page_count?: number;
  sort_by?: SortValues;
}

export interface PaginationResponse {
  bf_processed: boolean;
  current_page: number;
  next_page: number;
  prev_page: number;
  total_count: number;
  total_pages: number;
}

export interface PeoplePageResponse {
  data: PeoplePage[];
  meta: PaginationResponse;
}

export interface PeoplePageFetchState {
  initialLoadingState: boolean;
  peopleData: PeoplePageResponse;
  peopleDataError: boolean;
  peopleDataLoading: boolean;
  refetchPeopleData: () => Promise<void>;
}

export interface AutocompleteRequestParams {
  query: string;
}

export interface Person {
  face_uri: string;
  person_id: string;
  tag_name: string;
  tag_count?: number;
  bounding_box?: {
    left: number;
    top: number;
    width: number;
    height: number;
  };
}

export interface AutocompleteResponse {
  data: Person[];
}

export interface AutocompleteFetchState {
  autocompleteResults: Person[];
}
